import { useState } from "react";
import { H1, H3, P, Label, Span } from "../../../components/typography/styled";
import { ReferYourEmployerWrapper, ReferYourEmployerRow } from "./styled";
import { BaseFieldSet } from "../../../components/form/fieldset/styled";
import { BaseInput } from "../../../components/form/input/styled";
import { Logo, PrelimSetup } from "../../../assets";
import { BaseButton } from "../../../components/button/styled";
import { referEmployer } from "../../../utils/apis/referral/referEmployer";
import { DotLoader } from "react-spinners";
import { useNavigate } from "react-router-dom";
import { SuccessModal } from "../../../containers/app/modals/successmodal";

export const ReferYourEmployer = () => {
  const navigate = useNavigate();

  const [referForm, setReferForm] = useState({
    email: "",
    
  });
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setReferForm((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true);
    try {
      const response = await referEmployer(referForm);
      if (response) {
        setIsLoading(false);
        setIsSuccessModalOpen(true);
      }
    } catch (error) {
      setIsLoading(false);
      setError(`${error.message}`);
    }
  };
  const handleCloseSuccessModal = () => {
    setIsSuccessModalOpen(false);
    navigate("/");
  };

  const handlePersistModal = () => {
    return setIsSuccessModalOpen(true);
  };

  return (
    <>
      <SuccessModal
        open={isSuccessModalOpen}
        handleClickOutside={handlePersistModal}
        className={"update-plan-success-modal"}
        title={"Success"}
        message={"Employer referral submitted successfully"}
        callToAction={"Close"}
        handleCallToActionClick={handleCloseSuccessModal}
      />
      <ReferYourEmployerWrapper tocolumn={true}>
        <div className="refer-text">
          <div>
            <div className="logo-box-area">
              <Logo />
            </div>
            <H3>
              The #1 Employee Payroll Solution for Small and medium Businesses
            </H3>
            <P>
              Seamless Payroll management for your business all in one place!
            </P>
            <PrelimSetup style={{ width: "100%", height: "auto" }} />
            <P className="foot">POWERED BY: FOCUS GROUP</P>
          </div>
        </div>
        <div className="refer-form">
          <H1>Refer your Employer </H1>
          <P>
            Please provide the following details to refer your employer to
            workPlacePAY
          </P>
          <form onSubmit={handleSubmit}>
            <ReferYourEmployerRow>
              <BaseFieldSet>
                <Label>Referrer Email</Label>
                <BaseInput
                  type="email"
                  name="email"
                  placeholder="janedoe@example.com"
                  value={referForm.email}
                  onChange={(e) => handleChange(e)}
                  required
                />
              </BaseFieldSet>
              
            </ReferYourEmployerRow>
            <div>
              {error && (
                <P style={{ color: "red", marginBlockStart: 0 }}>{error}</P>
              )}
              <BaseButton
                backgroundcolor={"var(--color-primary)"}
                width={"fit-content"}
              >
                {isLoading ? (
                  <DotLoader size={20} color="white" className="dotLoader" />
                ) : (
                  <Span>Submit</Span>
                )}
              </BaseButton>
            </div>
          </form>
        </div>
      </ReferYourEmployerWrapper>
    </>
  );
};
